var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 53,
    viewBox: "0 0 91 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2322_2306)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 79,
    height: 41,
    rx: 14,
    fill: "#AEC3DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.44 21.84C34.48 23.1467 33.3 24.1733 31.9 24.92C30.5133 25.6667 29.0467 26.0467 27.5 26.06V24.18C28.7 24.18 29.86 23.86 30.98 23.22C32.1133 22.5667 33.0733 21.68 33.86 20.56C34.6467 19.44 35.16 18.2133 35.4 16.88L37.44 17.2C37.24 18.2933 36.8933 19.3333 36.4 20.32L43.72 24.38L42.8 26.04L35.44 21.84ZM44.16 29.7H36.62V34.48H34.6V29.7H27.1V27.86H44.16V29.7ZM60.4383 20.22V17H62.4183V26.6H60.4383V21.94H57.1183V20.22H60.4383ZM52.3583 22.72C51.7583 23.6667 50.9716 24.44 49.9983 25.04C49.0249 25.6267 47.9183 25.98 46.6783 26.1V24.32C48.0783 24.1333 49.1983 23.58 50.0383 22.66C50.8916 21.7267 51.3783 20.5533 51.4983 19.14H46.8983V17.44H57.7983V19.14H53.4783C53.4383 19.78 53.3116 20.4467 53.0983 21.14L58.3583 24.46L57.3783 25.94L52.3583 22.72ZM55.1783 27.16C57.4049 27.16 59.1916 27.44 60.5383 28C61.8849 28.56 62.5583 29.4333 62.5583 30.62C62.5583 31.8067 61.8849 32.68 60.5383 33.24C59.1916 33.8 57.4049 34.08 55.1783 34.08C52.9516 34.08 51.1649 33.8 49.8183 33.24C48.4716 32.68 47.7983 31.8067 47.7983 30.62C47.7983 29.4333 48.4716 28.56 49.8183 28C51.1649 27.44 52.9516 27.16 55.1783 27.16ZM55.1783 32.46C56.7383 32.46 58.0049 32.3067 58.9783 32C59.9649 31.68 60.4583 31.22 60.4583 30.62C60.4583 30.02 59.9649 29.5667 58.9783 29.26C58.0049 28.94 56.7383 28.78 55.1783 28.78C53.6183 28.78 52.3449 28.94 51.3583 29.26C50.3849 29.5667 49.8983 30.02 49.8983 30.62C49.8983 31.22 50.3849 31.68 51.3583 32C52.3449 32.3067 53.6183 32.46 55.1783 32.46Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2322_2306",
    x: 0,
    y: 0,
    width: 91,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313851 0 0 0 0 0.313851 0 0 0 0 0.313851 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2322_2306"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2322_2306",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBtn);
export default __webpack_public_path__ + "static/media/EditBtn.3d6d385d55f2ca81d708c11f5d7a2e0f.svg";
export { ForwardRef as ReactComponent };